import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2563eb',
      dark: '#1d4ed8',
      light: '#3b82f6',
      contrastText: '#ffffff'
    },
    error: {
      main: '#ef4444',
      dark: '#dc2626'
    },
    success: {
      main: '#10b981'
    },
    warning: {
      main: '#f59e0b'
    },
    background: {
      default: '#f5f8fa',
      paper: '#ffffff'
    },
    text: {
      primary: '#1f2937',
      secondary: '#4b5563'
    }
  },
  shape: {
    borderRadius: 8
  },
  typography: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
    button: {
      textTransform: 'none',
      fontWeight: 600
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          minHeight: 40,
          transition: 'background 0.18s ease, box-shadow 0.18s ease'
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#2563eb'
          }
        }
      }
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#f8fafc'
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 700,
          color: '#6b7280',
          fontSize: '0.75rem'
        }
      }
    }
  }
});

export default theme;
